

















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import EmployeeListItem from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/EmployeeModels/EmployeeListItem";
import EmployeesType from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Enums/EmployeesType";
@Component
export default class EmployeeListItemComponent extends Vue {
  @Prop({default:EmployeesType.Teachers})
  employeeType: EmployeesType;
  @Prop()
  employee: EmployeeListItem;

  getUrlDetail() {
    let routeName= 'teacher-detail';
    if(this.employeeType==EmployeesType.Administration)
      routeName = 'administration-detail';
    return {name:routeName, params:{id:this.employee.Id}}
  }
}
